// filepath: src/features/RADTool/RADStoreContext.js (or a suitable shared location)
import { createContext, useContext } from "react";

// Define the shape of the context value
/**
 * @typedef RADStoreContexValue
 * @property {() => Array<any>} getRADs - Function to retrieve the current array of RAD objects.
 * @property {(newRADs: Array<any>) => void} updateRADs - Function to update the entire array of RAD objects.
 */

/** @type {React.Context<RADStoreContexValue | null>} */
export const RADStoreContext = createContext(null);

/**
 * Hook to consume the RAD data context.
 * @returns {RADStoreContexValue} The RAD data context value.
 * @throws {Error} If used outside of a RADDataProvider.
 */
export const useRADStoreContext = () => {
  const context = useContext(RADStoreContext);
  if (!context) {
    throw new Error("useRADStoreContext must be used within a RADDataProvider");
  }
  return context;
};
